import { AmpersandIcon, BoldIcon, HighlighterIcon, ItalicIcon, SubscriptIcon, SuperscriptIcon, UnderlineIcon } from 'lucide-react';

import { AiToolbarButton } from '../toolbar/aiToolbarButton.component';
import { RedoToolbarButton, UndoToolbarButton } from '../toolbar/historyToolbarButton.component';
import { InsertToolbarButton } from '../toolbar/insertToolbarButton.component';
import { LinkToolbarButton } from '../toolbar/linkToolbarButton.component';
import { MarkToolbarButton } from '../toolbar/markToolbarButton.component';
import { Toolbar, ToolbarGroup } from './toolbar.component';

export const InlineToolbar = () => {
    return (
        <Toolbar>
            <ToolbarGroup>
                <UndoToolbarButton tooltip='Zpět' />
                <RedoToolbarButton tooltip='Vpřed' />
            </ToolbarGroup>
            <ToolbarGroup>
                <MarkToolbarButton nodeType='bold'tooltip='Tučné písmo'>
                    <BoldIcon />
                </MarkToolbarButton>
                <MarkToolbarButton nodeType='italic' tooltip='Kurzíva'>
                    <ItalicIcon />
                </MarkToolbarButton>
                <MarkToolbarButton nodeType='underline' tooltip='Podtržené'>
                    <UnderlineIcon />
                </MarkToolbarButton>
                <MarkToolbarButton nodeType='highlight' tooltip='Zvýraznění'>
                    <HighlighterIcon />
                </MarkToolbarButton>
                <MarkToolbarButton nodeType='superscript' tooltip='Horní index'>
                    <SuperscriptIcon />
                </MarkToolbarButton>
                <MarkToolbarButton nodeType='subscript' tooltip='Dolní index'>
                    <SubscriptIcon />
                </MarkToolbarButton>
            </ToolbarGroup>
            <ToolbarGroup>
                <LinkToolbarButton />
                <InsertToolbarButton insertText='&'>
                    <AmpersandIcon />
                </InsertToolbarButton>
                <AiToolbarButton />
            </ToolbarGroup>
        </Toolbar>
    );
};
